$(document).ready(function() {
    // init cookies consent
    if (typeof cookieConsent !== "undefined") {
        cookieConsent.init();
    }

    function tableFix143() {

        var nextBtn = document.querySelectorAll('.produto-table-container .table-next')[0];
        var prevBtn = document.querySelectorAll('.produto-table-container .table-prev')[0];

        if (nextBtn) {
            nextBtn.addEventListener('click', function() {
                document.querySelectorAll('.produto-table-container .table-next')[0].click();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function() {
                document.querySelectorAll('.produto-table-container .table-prev')[0].click();
            });
        }

    }

    tableFix143();

    // init dropdowns for selects
    $("select").selectpicker({
        noneResultsText: "Sem resultados: {0}",
        dropupAuto: false,
    });

    // date pickers ================
    const dayPicker = document.querySelectorAll(".date-picker-day");
    const monthPicker = document.querySelectorAll(".date-picker-month");
    const yearPicker = document.querySelectorAll(".date-picker-year");


    function checkValue(str, max) {
        if (str.charAt(0) !== '0' || str == '00') {
            var num = parseInt(str);
            if (isNaN(num) || num <= 0 || num > max) num = 1;
            str = num > parseInt(max.toString().charAt(0)) &&
                num.toString().length == 1 ? '0' + num : num.toString();
        };
        return str;
    };

    if (dayPicker) {
        dayPicker.forEach(
            (picker) => {
                new Datepicker(picker, {
                    format: "dd/mm/yyyy",
                    language: "pt",
                    autohide: true,
                    buttonClass: "btn",
                    nextArrow: ">",
                    prevArrow: "<",

                })

                picker.addEventListener('input', function(e) {
                    this.type = 'text';
                    var input = this.value;
                    if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
                    var values = input.split('/').map(function(v) {
                        return v.replace(/\D/g, '')
                    });
                    if (values[0]) values[0] = checkValue(values[0], 31);
                    if (values[1]) values[1] = checkValue(values[1], 12);
                    var output = values.map(function(v, i) {
                        return v.length == 2 && i < 2 ? v + ' / ' : v;
                    });
                    this.value = output.join('').substr(0, 14);
                });
            }

        );


    }

    //Note: 
    //Add attribute "future=[replace with year input name]" to <input>
    //allows future month year combinations only
    if (monthPicker) {
        monthPicker.forEach(picker => {
            let minDate = new Date();
            if (picker.getAttribute('future') != null && (matchYear = document.querySelector(`.date-picker-year[future=${picker.getAttribute('name')}]`))) {
                picker.addEventListener('blur', function(e) {
                    //if the month matches the current or previous month, then only future years are unlocked
                    if (picker.datepicker && picker.datepicker.dates && picker.datepicker.dates.length > 0) {
                        if (matchYear.datepicker) {
                            matchYear.datepicker.destroy();
                        }
                        minDate = new Date();
                        if (new Date(picker.datepicker.dates[0]).getMonth() > new Date().getMonth()) {
                            //allow current year selection
                            minDate.setFullYear(minDate.getFullYear() - 1);
                        }
                        return new Datepicker(matchYear, {
                            format: "yyyy",
                            language: "pt",
                            pickLevel: 2,
                            autohide: true,
                            buttonClass: "btn",
                            nextArrow: ">",
                            prevArrow: "<",
                            minDate: minDate
                        });
                    }
                });
            }
            return new Datepicker(picker, {
                format: "MM",
                language: "pt",
                pickLevel: 1,
                autohide: true,
                buttonClass: "btn",
                nextArrow: ">",
                prevArrow: "<",
                minDate: new Date(new Date().getFullYear(), 0, 1),
                maxDate: new Date(new Date().getFullYear(), 11, 31),
            });
        })
    }

    //Note: 
    //Add attribute "future=[replace with month input name]" to <input>
    //allows future month year combinations only
    if (yearPicker) {
        yearPicker.forEach(picker => {
            if (picker.getAttribute('future') != null && (matchMonth = document.querySelector(`.date-picker-month[future=${picker.getAttribute('name')}]`))) {
                picker.addEventListener('blur', function(e) {
                    //if the year matches the current year, then only future months are unlocked
                    if (matchMonth.datepicker) {
                        matchMonth.datepicker.destroy();
                    }
                    minDate = new Date();
                    if (picker.datepicker && picker.datepicker.dates && picker.datepicker.dates.length > 0 && picker.datepicker.dates[0] <= new Date().getTime()) {
                        //lock previous months
                        minDate = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 1);
                    } else {
                        //unlock all months
                        minDate = new Date(minDate.getFullYear(), 0, 1);
                    }
                    new Datepicker(matchMonth, {
                        format: "MM",
                        language: "pt",
                        pickLevel: 1,
                        autohide: true,
                        buttonClass: "btn",
                        nextArrow: ">",
                        prevArrow: "<",
                        minDate: minDate,
                        maxDate: new Date(new Date().getFullYear(), 11, 31),
                    })
                });
            }
            let minDate = new Date();
            if (picker.getAttribute('future') != null) {
                minDate.setFullYear(minDate.getFullYear() - 1);
            } else {
                minDate = new Date('0-0-1');
            }
            return new Datepicker(picker, {
                format: "yyyy",
                language: "pt",
                pickLevel: 2,
                autohide: true,
                buttonClass: "btn",
                nextArrow: ">",
                prevArrow: "<",
                minDate: minDate,
            });
        });
    } // header fixed

    // header fixed

    var header = document.getElementById("main-header");
    var threshold = 100;
    if (header) {
        var sticky = header.offsetTop + threshold;
        window.onscroll = function() {
            setHeaderSticky();
        };

        function setHeaderSticky() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                if (window.pageYOffset == 0) {
                    header.classList.remove("sticky");
                }
            }
        }
    }

    // TABS URL NAVIGATION
    function openTabsFromUrl() {
        var _url = window.location.href;
        var _path = _url.split("/");
        _path.forEach((tabName) => {
            var _tabElement = $('[data-url="' + tabName + '"]');
            if (_tabElement.length) {
                if (!_tabElement.hasClass("active")) {
                    _tabElement.click();
                }
            }
        });
    }

    openTabsFromUrl();

    $(".show-more-btn").on("click", function() {
        var _parent = $($($(this).parent()).parent());
        if (_parent.hasClass("show-all")) {
            _parent.removeClass("show-all");
            $(this).text($(this).data("open-label"));
            this.scrollIntoView(false);
        } else {
            _parent.addClass("show-all");
            $(this).text($(this).data("close-label"));
        }
    });

    window.showMoreTableSpan = function(e) {
        var element = $($(event.currentTarget).parent());
        event.currentTarget.remove();

        var _currentContent = $(element).text();
        $(element).text($(element).attr("data-content"));
        $(element).attr("data-content", _currentContent);
        $(element).append(
            '<strong class="show-less" onclick="showLessTableSpan()">Ver menos</strong>'
        );
    };

    window.showLessTableSpan = function(e) {
        var element = $($(event.currentTarget).parent());
        event.currentTarget.remove();
        var _currentContent = $(element).text();
        $(element).text($(element).attr("data-content"));
        $(element).attr("data-content", _currentContent);
        $(element).append(
            '<strong class="show-less" onclick="showMoreTableSpan()">Ver mais</strong>'
        );
    };

    $("table:not(.product-table) tr span").each(function(index, element) {
        var _content = $(element).text();
        if (_content.length >= 40) {
            $(element).attr("data-content", _content);
            $(element).text(_content.substring(0, 30) + "...");
            $(element).append(
                '<strong class="show-more" onclick="showMoreTableSpan()">Ver mais</strong'
            );
        }
    });

    // MENU AND SEARCH ===========
    // open menu
    $("#menu-btn").on("click", function() {
        $(".main-menu").addClass("show menu");
        $("body").addClass("noscroll");
    });
    // open search
    $("#search-btn").on("click", function() {
        $(".main-menu").addClass("show search");
        $("body").addClass("noscroll");
    });
    // close menu overlay
    $("#close-menu").on("click", function() {
        $(".main-menu").removeClass("show menu search");
        $("body").removeClass("noscroll");
    });
    //icon click submits search form
    $(".main-menu--search-inner-content .search-icon, .search-results-header .search-icon").on("click", function (event) {
        var form = $(event.target).closest("form");
        if (form)
            form.submit();
    });

    // handle search sugestions =============
    // ======================================
    function delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this,
                args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                callback.apply(context, args);
            }, ms || 0);
        };
    }
    // the event will only fire after user stops
    // typing for 500ms because of delay function
    /* $(".main-menu").on(
         "keyup",
         "input.search-input",
         delay(function(e) {
             // console.log('input current val', $(this).val());
             if ($(this).val().length < 3) {
                 $(this).parent().find(".dropdown-menu").removeClass("show");
                 $(this)
                     .closest(".main-menu--search-inner-content .search")
                     .removeClass("sugestions");
                 return;
             }
             console.log("searching for:", $(this).val());
             $(this).parent().find(".dropdown-menu").addClass("show");
             $(this)
                 .closest(".main-menu--search-inner-content .search")
                 .addClass("sugestions");
         }, 500)
     );*/

    // FAQ 2lvl navigation =================
    // =====================================

    function handleTabChange(tab) {
        // remove active state from all tabs
        $(".faq-tab").removeClass("active").attr("aria-selected", "false");

        $(tab).addClass("active").attr("aria-selected", "true");

        // extract associate panel from href
        var href = $(tab).attr("href");

        if (href.charAt(0) !== "/") {
            var associatePanel = $(href);

            // console.log('tab', tab);
            // console.log('href', href);
            // console.log('associatePanel', associatePanel);

            // hide all panels
            $(".tab-pane").removeClass("show active");
            // show associate panel
            $(associatePanel).addClass("show active");
        }

    }

    function updateDropdownFromTab(tab) {
        var value = $(tab).text();
        var currentSelectPicker = $(tab)
            .parent()
            .parent()
            .parent()
            .find(".selectpicker.tab-picker");
        $(currentSelectPicker).selectpicker("val", value);
    }

    // CLICKED TAB ITEM
    function faqTabSelected(tab) {
        // bottom margin for dropdown on small devices
        $(".nav-tabs--container").removeClass("dropdown-md-spacer");
        // collapse all subnavs if not clicked on any subnav item
        var isSubLink = $(tab).hasClass("sub-nav-link");
        if (!isSubLink) {
            // remove styles from group tab
            $(".nav-link--with-subnav")
                .removeClass("active")
                .addClass("collapsed")
                .attr("aria-expanded", "false");
            // collapse all sub menus
            $("#faq-menu").find(".collapse").collapse("hide");
        } else {
            // bottom margin for dropdown on small devices
            $(".nav-tabs--container").addClass("dropdown-md-spacer");
            updateDropdownFromTab(tab);
        }

        var isHorizontalSubLink = $(tab)
            .parent()
            .parent()
            .hasClass("horizontal-sub-nav-menu");
        if (isHorizontalSubLink) {
            $(".nav-link--with-subnav").removeClass("active");

            const parentTab = $(tab)
                .closest(".nav-item")
                .find(".nav-link--with-subnav");
            $(parentTab).addClass("active");
        }

        handleTabChange(tab);
    }

    function updateTabNavigationUrl(tab) {
        //update url
        if (tab && $(tab).data("relativeurl") && window.location.pathname != $(tab).data("relativeurl")) {
            window.history.pushState({}, '', $(tab).data("relativeurl"));
        }
    }

    //browser back button upates faq (auto user tab click)

    $(window).bind('popstate', function() {
        var tabs = $("#faq-menu").find("a[class^='nav-link'][data-relativeurl='" + window.location.pathname + "']");
        if (tabs.length > 0) {
            tabs[0].click();
        }
    });



    //Run the tab selected logic on the first page load
    $("a[class^='nav-link'].active").each(function() {
        tabSelected(this);
    });

    $(".nav-item").off("click");
    $(".nav-item").on("click", function(e) {
        tabSelected(e.target);
    });

    $('.nav-link.nav-link--with-subnav').on('click', function(e) {

        e.preventDefault();

    });


    function tabSelected(tab) {
        if (tab.matches('a[class*="nav-link--with-subnav"]')) {
            $('.nav-link').removeClass('active');
            tabWithSubnavSelected(tab);
            //   updateTabNavigationUrl(tab);
        } else if (tab.matches('a[class*="faq-tab"]')) {
            faqTabSelected(tab);
            updateTabNavigationUrl(tab);
        } else {
            //left empty (this code can run for .nav-item elements not in faq page)
        }

    }



    function tabWithSubnavSelected(tab) {
        var linksWithSubNavs = $(tab)
            .parent()
            .parent()
            .find(".nav-link--with-subnav");
        $(linksWithSubNavs)
            .addClass("collapsed")
            .removeClass("active")
            .attr("aria-expanded", "false");
        $(tab)
            .addClass("active")
            .removeClass("collapsed")
            .attr("aria-expanded", "true");

        //var collapseMenuId = $(this).attr("data-target");
        var firstSubTab = $(tab).parent().find("li").first().children("a");
        var firstSubTabText = $(firstSubTab).text();

        // reset dropdown to first item
        var currentSelectPicker = $(tab).parent().find(".selectpicker.tab-picker");
        if (!window.mobileAndTabletCheck()) {
            $(currentSelectPicker).selectpicker("val", firstSubTabText);
        }


        // bottom margin for dropdown on small devices
        $(".nav-tabs--container").addClass("dropdown-md-spacer");

        // passing first sub tab to open automatically when clicked group tab
        handleTabChange(firstSubTab);
    }

    // handle select picker update
    $(".selectpicker.tab-picker").off("changed.bs.select");
    // handle select picker update


    window.mobileAndTabletCheck = function() {
        let check = false;
        (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check || (window.innerWidth < 991);
    };

    function tabSelectorDropdownActivator() {
        $(".selectpicker.tab-picker").off("changed.bs.select");
        $(".selectpicker.tab-picker").off("hidden.bs.select");

        $(".selectpicker.tab-picker").each(function() {
            $this = $(this);
            $(this).closest(".nav-item").find("ul.sub-nav-menu li.sub-nav-item a").each(function() {
                if ($(this).attr('href').charAt(0) == "/") {
                    $this.attr('title', 'Tópico');
                    $this.selectpicker('val', '')
                }
            });
        })


        $(".selectpicker.tab-picker").on(
            "changed.bs.select",
            function(e) {
                var linkIndex = e.target.selectedIndex + 1;
                var tab = $(e.target)
                    .closest(".nav-item")
                    .find("ul.sub-nav-menu li.sub-nav-item:nth-child(" + linkIndex + ") a");


                if (tab.attr("href").charAt(0) == '/') {
                    window.location = tab.attr("href");
                } else {
                    if (tab.attr("href").charAt(0) == '#') {
                        window.location.replace(tab.attr("href"));
                    }
                }

                handleTabChange(tab);
            }
        );

    }
    tabSelectorDropdownActivator();
    window.addEventListener('resize', tabSelectorDropdownActivator);

    var owl = $(".owl-carousel.hero-slider");
    var round = 0;
    owl.owlCarousel({
        loop: true,
        items: 1,
        margin: 0,
        nav: true,
        dots: true,
        autoplaySpeed: 700,
        autoplay: true,
        // autoHeight:true,
        onChanged: function(e) {
            var $currentItem = $(".owl-item", owl).eq(e.item.index);
            var state = "";

            var $elemsToanim = $currentItem.find("[data-animation-in" + state + "]");

            var _color = $currentItem.find(".hero-slider--item").data("color");
            $(".hero-slider--background").css("background-color", _color);

            $elemsToanim.addClass("animated");
            // console.log($elemsToanim);

            setAnimation($elemsToanim, "in" + state);
        },
        onInitialized: function(e) {
            var $currentItem = $(".owl-item", owl).eq(e.item.index);

            var _color = $currentItem.find(".hero-slider--item").data("color");
            $(".hero-slider--background").css("background-color", _color);
        },
    });

    function setAnimation(_elem, _InOut) {
        // Store all animationend event name in a string.
        var animationEndEvent =
            "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";

        _elem.each(function() {
            var $elem = $(this);
            var $animationType = "animated " + $elem.data("animation-" + _InOut);

            $elem.addClass($animationType).one(animationEndEvent, function() {
                $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
            });
        });
    }

    owl.on("translated.owl.carousel", function(event) {
        if (event.item.index == event.page.count - 1) {
            if (round < 1) {
                round++;
            } else {
                owl.trigger("stop.owl.autoplay");
                var owlData = owl.data("owl.carousel");
                owlData.settings.autoplay = false; //don't know if both are necessary
                owlData.options.autoplay = false;
                owl.trigger("refresh.owl.carousel");
            }
        }
    });

    // Contact Form Enable Submit Button
    $("#formulario-contacto input").on("change", function() {
        checkFormIsFilled();
    });
    $("#formulario-contacto textarea").on("change", function() {
        checkFormIsFilled();
    });

    function checkFormIsFilled() {
        var inputsFilled = areInputsFilled();
        var messageFilled = $("#formulario-contacto textarea").val();
        var gaveConsent = $("#formulario-contacto-consentimento-privacidade").prop(
            "checked"
        );

        if (inputsFilled && messageFilled && gaveConsent) {
            $("#formulario-contacto .btn").attr({
                disabled: false,
                "aria-disabled": false,
            });
        }
    }

    function areInputsFilled() {
        var fieldsValues = [];

        $("#formulario-contacto input").each(function() {
            fieldsValues.push($(this).val());
        });

        var hasEmptyFields = fieldsValues.some((element) => !element);

        if (!hasEmptyFields) {
            return true;
        }
        return false;
    }

    // Conteudo Carousel Slider
    var contentCarousel = $(".owl-carousel.conteudo-carousel");

    function updateProgress(e) {


        var total_pages = e.item.count / e.page.size;

        if (total_pages <= 1) {
            $(e.target).next(".progress-container").addClass('d-none');
            return;
        }

        $(e.target).next(".progress-container").removeClass('d-none');

        var current_page = e.relatedTarget.relative(e.item.index) / e.page.size + 1;
        var percentual_value = (current_page * 100) / total_pages;
        var progress_element = $(e.target).next(".progress-container");
        var current_to_show = ((Math.round(current_page) < current_page) ? (Math.round(current_page) + 1) : Math.round(current_page));
        var total_to_show = ((Math.round(total_pages) < total_pages) ? (Math.round(total_pages) + 1) : Math.round(total_pages));
        progress_element.find("span").text(current_to_show + "/" + total_to_show);
        progress_element
            .find(".progress-bar")
            .attr("aria-valuenow", percentual_value);
        progress_element.find(".progress-bar").css("width", percentual_value + "%");
    }

    if (contentCarousel.length) {
        contentCarousel.each(function(index, carousel) {
            var _carousel = $(carousel);

            _carousel.owlCarousel({
                loop: false,
                margin: 20,
                nav: true,
                dots: false,
                responsive: {
                    0: {
                        items: 1,
                        slideBy: 4,
                    },
                    600: {
                        items: 2,
                        slideBy: 2,
                    },
                    1000: {
                        items: 4,
                        slideBy: 4,
                    },
                },
                onInitialized: updateProgress,
                onChanged: updateProgress,
                onResized: updateProgress,
            });
        });
    }

    // Glossary Navigation start
    function smoothScrollNavigation(left) {
        var value = left ? 120 : -120;

        $(".glossario .nav.nav-tabs")
            .stop()
            .animate({
                    scrollLeft: Math.max(
                        $(".glossario .nav.nav-tabs").scrollLeft(),
                        $(".glossario .nav.nav-tabs").scrollLeft()
                    ) + value,
                },
                500,
                "linear",
                function() {
                    window.smoothScrollNavigationTimeOut = setTimeout(
                        smoothScrollNavigation(left),
                        0
                    );
                }
            );
    }

    function scrollNavigationClasses() {
        var scrollLeftValue = $(".glossario .nav.nav-tabs").scrollLeft();
        var scrollLeftMaxValue =
            $(".glossario .nav.nav-tabs").get(0).scrollWidth -
            $(".glossario .nav.nav-tabs").get(0).clientWidth;

        if (scrollLeftValue > 0) {
            $(".navigation .navigation-prev").removeClass("innactive");
        } else {
            $(".navigation .navigation-prev").addClass("innactive");
        }

        if (scrollLeftValue < scrollLeftMaxValue) {
            $(".navigation .navigation-next").removeClass("innactive");
        } else {
            $(".navigation .navigation-next").addClass("innactive");
        }
    }

    $(".glossario .nav.nav-tabs").on("scroll", scrollNavigationClasses);

    $(".glossario .navigation .navigation-next")
        .on("mousedown touchstart", function() {
            smoothScrollNavigation(true);
        })
        .on("mouseup touchend", function() {
            $(".glossario .nav.nav-tabs").stop();
            clearTimeout(window.smoothScrollNavigationTimeOut);
        });

    $(".glossario .navigation .navigation-prev")
        .on("mousedown touchstart", function() {
            smoothScrollNavigation(false);
        })
        .on("mouseup touchend", function() {
            $(".glossario .nav.nav-tabs").stop();
            clearTimeout(window.smoothScrollNavigationTimeOut);
        });

    //glossary navigation end

    // LightBox Setup
    var lightbox = new SimpleLightbox(".gallery a", { uniqueImages: false });


  

    js_jquery_init_simulatorTables();
    // Table Popover ===================
    js_jquery_init_popovers();

    // Product document downloader selector
    $("#document-downloader-selector").on(
        "changed.bs.select",
        function(e, clickedIndex, isSelected, previousValue) {
            // update download link with correct file
            $(".produto-download .download-btn").attr("href", e.target.value);
        }
    );

    // Produto Carousel Slider
    var produtoCarousel = $(".owl-carousel.produto-carousel");
    produtoCarousel.owlCarousel({
        loop: false,
        stagePadding: 40,
        margin: 20,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            426: {
                items: 2,
                slideBy: 2,
            },
            1024: {
                items: 3,
                slideBy: 3,
                stagePadding: 80,
            },
        },
        onInitialized: updateProgress,
        onChanged: updateProgress,
        onResized: updateProgress,
    });

    // Simulador Page Alterar Dados
    $(".alterar-dados-btn").on("click", function(e) {
        $(".simulador-seguro-page-alterar-dados").addClass("show");
        $("body").addClass("noscroll");
    });
    $(".simulador-seguro-page-alterar-dados button.close").on(
        "click",
        function(e) {
            $(".simulador-seguro-page-alterar-dados").removeClass("show");
            $("body").removeClass("noscroll");
        }
    );

    // Drawer right
    $(".modal.white-backdrop").on("show.bs.modal", function(e) {
        $("body").addClass("white-backdrop");
    });
    $(".modal.white-backdrop").on("hidden.bs.modal", function(e) {
        $("body").removeClass("white-backdrop");
    });

    // lvl 2 modal (used in nif validation)
    $(".js-modal-lvl-2").on("show.bs.modal", function(e) {
        $("body").addClass("force-dark-backdrop");
    });
    $(".js-modal-lvl-2").on("hidden.bs.modal", function(e) {
        $("body").removeClass("force-dark-backdrop");
    });

    class Swipe {
        constructor(element) {
            this.xDown = null;
            this.yDown = null;
            this.element = typeof(element) === 'string' ? document.querySelector(element) : element;
            if (this.element) {
                this.element.addEventListener('touchstart', function(evt) {
                    this.xDown = evt.touches[0].clientX;
                    this.yDown = evt.touches[0].clientY;
                }.bind(this), false);
            }


        }

        onLeft(callback) {
            this.onLeft = callback;

            return this;
        }

        onRight(callback) {
            this.onRight = callback;

            return this;
        }

        onUp(callback) {
            this.onUp = callback;

            return this;
        }

        onDown(callback) {
            this.onDown = callback;

            return this;
        }

        handleTouchMove(evt) {
            if (!this.xDown || !this.yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            this.xDiff = this.xDown - xUp;
            this.yDiff = this.yDown - yUp;

            if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) { // Most significant.
                if (this.xDiff > 0) {
                    this.onLeft();
                } else {
                    this.onRight();
                }
            } else {
                if (this.yDiff > 0) {
                    this.onUp();
                } else {
                    this.onDown();
                }
            }

            // Reset values.
            this.xDown = null;
            this.yDown = null;
        }

        run() {
            if (this.element) {
                this.element.addEventListener('touchmove', function(evt) {
                    this.handleTouchMove(evt);
                }.bind(this), false);
            }
        }
    }


    // One-liner.

    (new Swipe('.fixed-simulator')).onDown(function() {
        $($(this.element).find('.expand-btn')).click();
    }).run();


    //Hide collapse button if content has no height for it
    if ($('#collapse-body p').height() <= 140) {
        $('#collapse-body + .view-more').addClass('d-none');
    }

});

function js_jquery_init_simulatorTables() {
    // PRODUCT TABLE WITH HTML TABLE
    const HTMLtables = $(".produto-table-container");
    HTMLtables.each(function () {
        // Elements References
        const tableRef = this;
        const tableGroupOne = $(this).find(".group-1");
        const tableGroupTwo = $(this).find(".group-2");
        const mobileNav = $(this).find(".table-mobile-nav");

        // Data Attributes
        const totalCols = $(tableRef).data("total-cols");
        const totalGroups = $(tableRef).data("total-groups");
        const secondGroupStart = $(tableRef).data("second-group-col");

        // State
        let activeGroup = 1;
        let activeCol = 1;

        // init with first group
        tableGroupOne.addClass("group-active");
        // init first col for mobile
        const activeColumnTitle = $(tableRef)
            .find(".column-title.table-col-1")
            .text();
        $(tableRef).find(".current-col-name").text(activeColumnTitle);

        $(this)
            .find(".tab-group-1")
            .on("click", function () {
                // update state
                activeGroup = 1;
                activeCol = 1;
                // change tab
                $(tableRef).find(".tab-group-2").removeClass("active");
                $(tableRef).find(".tab-group-1").addClass("active");
                // change col
                $(tableRef).find(".cell-item.active").removeClass("active");
                $(tableRef).find(".table-col-1").addClass("active");
                // change group
                tableGroupTwo.removeClass("group-active");
                tableGroupOne.addClass("group-active");
                // update mobile nav
                $(tableRef).find(".table-next").addClass("show");
                $(tableRef).find(".table-prev").removeClass("show");
                updateMobileNavText(1);
                mobileNav.removeClass("bg-light-blue");
                mobileNav.addClass("bg-primary");
            });

        $(this)
            .find(".tab-group-2")
            .on("click", function () {
                // update state
                activeGroup = 2;
                activeCol = secondGroupStart;
                // change tab
                $(tableRef).find(".tab-group-1").removeClass("active");
                $(tableRef).find(".tab-group-2").addClass("active");
                // change col
                $(tableRef).find(".cell-item.active").removeClass("active");
                $(tableRef).find(`.table-col-${secondGroupStart}`).addClass("active");
                // change group
                tableGroupOne.removeClass("group-active");
                tableGroupTwo.addClass("group-active");
                // update mobile nav
                $(tableRef).find(".table-next").addClass("show");
                $(tableRef).find(".table-prev").removeClass("show");
                updateMobileNavText(secondGroupStart);
                mobileNav.removeClass("bg-primary");
                mobileNav.addClass("bg-light-blue");
            });

        $(tableRef)
            .find(".table-next")
            .on("click", function () {
                activeCol++;

                $(tableRef).find(".cell-item.active").removeClass("active");
                $(tableRef)
                    .find(`.cell-item.table-col-${activeCol}`)
                    .addClass("active");
                updateMobileNavText(activeCol);

                $(tableRef).find(`.table-prev`).addClass("show");
                if (activeCol === totalCols) {
                    $(tableRef).find(`.table-next`).removeClass("show");
                }
                if (activeGroup === 1 && activeCol === secondGroupStart - 1) {
                    $(tableRef).find(`.table-next`).removeClass("show");
                }
            });

        $(tableRef)
            .find(".table-prev")
            .on("click", function () {
                activeCol--;

                $(tableRef).find(".cell-item.active").removeClass("active");
                $(tableRef)
                    .find(`.cell-item.table-col-${activeCol}`)
                    .addClass("active");
                updateMobileNavText(activeCol);

                $(tableRef).find(`.table-next`).addClass("show");
                if (activeCol === 1) {
                    $(tableRef).find(`.table-prev`).removeClass("show");
                }
                if (activeGroup === 2 && activeCol === secondGroupStart) {
                    $(tableRef).find(`.table-prev`).removeClass("show");
                }
            });

        function updateMobileNavText(colNo) {
            const activeColumnTitle = $(tableRef)
                .find(`.column-title.table-col-${colNo}`)
                .text();
            $(tableRef).find(".current-col-name").text(activeColumnTitle);
        }
    });

    // simulador tables
    $(".simulador-table .table-next").on("click", function (e) {
        const thisTable = $(e.target).closest(".simulador-table");
        const totalCols = thisTable.data("table-cols");
        const activeCol = thisTable.data("active-col");
        const nextCol = activeCol + 1;

        thisTable.find(".cell-item.active").removeClass("active");
        thisTable.find(`.cell-item.table-col-${nextCol}`).addClass("active");
        thisTable.data("active-col", nextCol);

        thisTable.find(`.table-prev`).addClass("show");
        if (nextCol === totalCols) {
            thisTable.find(`.table-next`).removeClass("show");
        }
    });
    $(".simulador-table .table-prev").on("click", function (e) {
        const thisTable = $(e.target).closest(".simulador-table");
        const activeCol = thisTable.data("active-col");
        const prevCol = activeCol - 1;

        thisTable.find(".cell-item.active").removeClass("active");
        thisTable.find(`.cell-item.table-col-${prevCol}`).addClass("active");
        thisTable.data("active-col", prevCol);

        thisTable.find(`.table-next`).addClass("show");
        if (prevCol === 1) {
            thisTable.find(`.table-prev`).removeClass("show");
        }
    });
}

function js_jquery_init_popovers() {
    var items_to_blur = [
        ".produto-hero",
        ".main-header",
        ".main-header",
        ".fixed-simulator",
        ".produto-tabs",
        ".produto-table-grid *:not(.unblur)",
        "footer",
        ".produto-legal-section",
        ".produto-links",
        ".produto-download",
        ".produto-slider",
        '.product-table',
        '.bbo_header',
        '#bbo_options',
        '.auto-simulator',
        '.breadcrumb-item'
    ];
    $("i.fa-info-circle")
        .popover({
            trigger: "click",
            placement: "top",
            container: "body",
            html: true,
            template: `
      <div class="popover produto-table-popover" role="tooltip">
        <div class="arrow"></div>
        <div class="popover-header-container">
          <span class="popover-close">
            <img src="/img/close-icon-gray.svg" />
          </span>
        </div>
        <div class="popover-body"></div>
      </div>`,
        })
        .on("show.bs.popover", function (e) {
            //hide any visible popover

            $(".produto-table-popover").not(this).popover("hide");
            $(e.target).addClass("unblur");
            $(e.target).parent().addClass("unblur");
            $(e.target).parent().parent().addClass("unblur");

            items_to_blur.forEach((el) => {
                $(el).css("filter", "blur(2px)");
            });
        })
        .on("shown.bs.popover", function (e) {
            //close on cancel
            $(".popover-close").on("click", function () {
                $(".produto-table-popover").popover("hide");
            });
        })
        .on("hide.bs.popover", function (e) {
            //close on cancel
            $(".unblur").removeClass("unblur");
            items_to_blur.forEach((el) => {
                $(el).css("filter", "none");
            });
        });

        $(".js-tab-btn").on("click", function () {
          tabActiveStepper();
        });

    $(document).mouseup(function (e) {
        var container = new Array(); container.push($(".produto-table-popover"));
        $.each(container, function (key, value) {
            if (!$(value).is(e.target) && // if the target of the click isn't the container...      
                $(value).has(e.target).length === 0 // ... nor a descendant of the container    
            ) {
                $(value).popover("hide");
            }
        });
    });

}

function tabActiveStepper() {
  $(".custom-stepper .nav-item").removeClass("open");
  $(".custom-stepper .nav-item .nav-link.active").parent().addClass("open");
}

$(window).on('load', function() {
  tabActiveStepper();
})

$(document).ajaxComplete(function() {
  tabActiveStepper();
})